import { IScrollSliderItem } from "~/components/slider/ScrollSlider.vue";
import {
  AppLink,
  OfficeContact,
  SocialNetwork,
} from "~/types/content";

const STORE_NAMESPACE = "content";

export interface Content {
  companies: IScrollSliderItem[];
  officeContact: OfficeContact;
  appLinks: AppLink[];
  socialNetworks: SocialNetwork[];
  videoLink: string;
}

export const DEFAULT_CONTENT: Content = {
  companies: [
    {
      name: "",
      imageUrl: "",
      icon: "",
      description: "",
      id: "",
      feedback: "",
      link: "",
      image: {
        modernFormatImage: {
          "desktop-path": "",
          "desktop-path-retina": "",
        },
        fallbackFormatImage: {
          "desktop-path": "",
          "desktop-path-retina": "",
        },
        alt: "",
        width: 0,
        height: 0,
        loading: "eager",
      },
    },
  ],
  officeContact: {
    phone: [],
    email: [],
    officeMarker: [0, 0],
    blocks: {
      block1: [],
      block2: [],
      block3: [],
      block4: [],
      block5: [],
      block6: [],
    }
  },
  appLinks: [
    {
      link: "",
      icon: "",
      device: "",
    },
  ],
  socialNetworks: [
    {
      link: "",
      value: "",
    },
  ],
  videoLink: ""
};

export const useContentStore = defineStore(STORE_NAMESPACE, {
  state() {
    return DEFAULT_CONTENT;
  },

  getters: {
    getContacts(state) {
      return state.officeContact;
    },
    getVideoLink(state) {
      return state.videoLink;
    },
    getAppLinks(state) {
      return state.appLinks;
    },
    getSocialNetworks(state) {
      return state.socialNetworks;
    }
  },
  actions: {
    saveContent(content: Content) {
      this.$state = {...content};
    },
  },
});
